import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const STATUS_TRIGGER = {
  Active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Completed: "bg-blue-50 text-blue-700 border-blue-200",
  Delivered: "bg-violet-50 text-violet-700 border-violet-200",
  Draft: "bg-slate-50 text-slate-600 border-slate-200",
};

const OPTIONS = ["Draft", "Active", "Completed", "Delivered"];

export function JobStatusSelect({ jobId, status, code, className = "", invalidateKeys = [] }) {
  const qc = useQueryClient();

  const change = async (next) => {
    if (next === status) return;
    try {
      await api.put(`/jobs/${jobId}`, { job_status: next });
      toast.success(`Job Status updated to ${next}`);
      invalidateKeys.forEach((k) => qc.invalidateQueries({ queryKey: k }));
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()} className="inline-block">
      <Select value={status || undefined} onValueChange={change}>
        <SelectTrigger className={`h-8 w-36 ${STATUS_TRIGGER[status] || ""} ${className}`} data-testid={`job-status-select-${code || jobId}`}>
          <SelectValue placeholder="Set status" />
        </SelectTrigger>
        <SelectContent>
          {OPTIONS.map((s) => (
            <SelectItem key={s} value={s} data-testid={`job-status-option-${s}`}>{s}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
